import React from "react";
import { Loader2Icon, LucideProps } from "lucide-react";
import styled, { keyframes } from "styled-components";
import Flex from "../../Flex";

const rotate = keyframes`
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
`;

const Wrapper = styled(Flex)`
    animation: ${rotate} 1s linear infinite;
`;

export const Spinner = (props: LucideProps) => (
    <Wrapper alignItems="center" column justifyContent="center">
        <Loader2Icon {...props} />
    </Wrapper>
);
